/*  Admin Routes */
export default [
  // Offers
  // ---------------
  {
    path: '/jobs/offers/',
    name: 'all-offers',
    meta: {
      name: 'main.routes.all-offers',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/admin/Offers.vue')
  },
  // ---------------

  // Companies
  // ---------------
  {
    path: '/jobs/admin/companies',
    name: 'admin-companies',
    meta: {
      name: 'main.routes.all-companies',
      layout: 'jobs',
      auth: true
    },
    component: () => import('@/views/jobs/admin/Companies.vue')
  },
  {
    path: '/jobs/admin/company/:id',
    name: 'admin-one-company',
    meta: {
      name: 'main.routes.one-company',
      layout: 'jobs',
      auth: true
    },
    component: () => import('@/views/jobs/admin/OneCompany.vue')
  },
  // ---------------

  // Users
  // ---------------
  {
    path: '/admin/users',
    name: 'admin-users',
    meta: {
      name: 'main.routes.all-users',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/admin/Users.vue')
  },
  {
    path: '/admin/user/:id',
    name: 'one-user',
    meta: {
      name: 'main.routes.one-user',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/admin/OneUser.vue')
  },
  // ---------------

  // Payments
  // ---------------
  {
    path: '/jobs/admin/payments',
    name: 'admin-payments',
    meta: {
      name: 'main.routes.all-payments',
      layout: 'jobs',
      auth: true
    },
    component: () => import('@/views/jobs/admin/Payments.vue')
  },
  // ---------------

  // Promos
  // ---------------
  {
    path: '/jobs/admin/promos',
    name: 'admin-promos',
    meta: {
      name: 'main.routes.all-promos',
      layout: 'jobs',
      auth: true
    },
    component: () => import('@/views/jobs/admin/Promos.vue')
  },
  // ---------------

  // Referals
  // ---------------
  {
    path: '/jobs/admin/referrals',
    name: 'admin-referrals',
    meta: {
      name: 'main.routes.all-referrals',
      layout: 'jobs',
      auth: true
    },
    component: () => import('@/views/jobs/admin/Referrals.vue')
  },
  {
    path: '/jobs/admin/referral/:id',
    name: 'admin-referral',
    meta: {
      name: 'main.routes.one-referral',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/admin/OneReferral.vue')
  },
  // ---------------

  //Administer HR
  // ---------------
  {
    path: '/jobs/admin/hr/list',
    name: 'admin-hr',
    meta: {
      name: 'main.routes.all-hrs',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/admin/Headhunters.vue')
  },
  {
    path: '/jobs/admin/hr/add',
    name: 'admin-add-hr',
    meta: {
      name: 'main.routes.add-hr',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/admin/AddHeadhunter.vue')
  },
  {
    path: '/jobs/admin/hr/manage/:id',
    name: 'manage-hr',
    meta: {
      name: 'main.routes.manage-hr',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/admin/ManageHeadhunter.vue')
  },
  // ---------------

  // Roles and Permissions
  // (Not in Menu)
  // ---------------
  {
    path: '/admin/roles',
    name: 'admin-roles',
    meta: {
      name: 'main.routes.roles',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/admin/Roles.vue')
  },
  {
    path: '/admin/permissions/:id',
    name: 'admin-permissions',
    meta: {
      name: 'main.routes.permissions',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/admin/Permissions.vue')
  },
  // ---------------
]
